import RemoteResource from "../remoteResource/RemoteResource";
import UpcomingUserAppointments from "../../models/domain/UpcomingUserAppointment";
import UpcomingUserWaitlist from "../../models/domain/UpcomingUserWaitlist";
import useUpcomingUserAppointments from "./useUpcomingUserAppointments";
import useUpcomingUserWaitlist from "./useUpcomingUserWaitlist";
import UpcomingUserAppointmentsList from "../../models/domain/UpcommingUserAppointmentsList";

class UpcomingUserVisit {
  constructor(
    public readonly upcomingAppointments: RemoteResource<
      UpcomingUserAppointmentsList | undefined
    >,
    public readonly upcomingWaitlist: RemoteResource<UpcomingUserWaitlist>,
  ) {}
}

export default function useUpcomingUserVisit(
  patientId: string,
  userProfile: any,
): UpcomingUserVisit {
  const upcomingUserAppointments = useUpcomingUserAppointments(
    {
      attendeeId: patientId,
    },
    userProfile,
  );
  const upcomingUserWaitlist = useUpcomingUserWaitlist({
    patientId: patientId,
  });

  return new UpcomingUserVisit(upcomingUserAppointments, upcomingUserWaitlist);
}
